import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { UrlManageService } from '../services/url-manage.service';

@Injectable({
  providedIn: 'root'
})
export class ProteinDetailService {

constructor(
  private http: HttpClient,
  private urlManagement: UrlManageService
) { }

detail_data;
detail_list=[];
object_keys: Array<string>;

/*
getProteinDetail(logic_id){
  this.http.get(this.urlManagement.getProteinDetail + logic_id).subscribe(params=> {
    this.object_keys = Object.keys(params);
    this.object_keys.forEach((val, idx, array)=>{
      const detail_object = {
        "name": null,
        "value": null
      }
      detail_object.name = val;
      detail_object.value = params[val];
      this.detail_list.push(detail_object);
    })
  })
  return this.detail_list;
}
*/

getProteinDetail(logic_id){
  return this.http.get(this.urlManagement.getProteinDetail + logic_id);
}


}
